import { render, staticRenderFns } from "./AddAfterDev.vue?vue&type=template&id=36fb4d1c&scoped=true"
import script from "./AddAfterDev.vue?vue&type=script&lang=ts"
export * from "./AddAfterDev.vue?vue&type=script&lang=ts"
import style0 from "./AddAfterDev.vue?vue&type=style&index=0&id=36fb4d1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fb4d1c",
  null
  
)

export default component.exports